<template>
  <SectionRestitution
    :key="ongletActif"
    :blocs="blocs"
    :champ-total="champTotal"
    :evolution-total="evolutionTotal"
    :valeurs-evolution-total="valeursEvolutionTotal"
    :champ-total-groupe="champTotalGroupe"
    :libelle-total="libelleTotal"
    :hausse-favorable="hausseFavorable"
    :unite="unite"
    :has-evolution="hasEvolution"
  />
</template>
<script>
import SectionRestitution from './section-restitution.vue'
import { CHARGES_FIXES, CHARGES_VARIABLES, AUTRES_PRODUITS, COPRODUITS, construireSection, pourcentageEvolution, valeursParAnnee } from '@/utils/restitution-postes'
import { UNITE_TONNE } from '@/utils/restitution'

const SECTIONS = {
  'Charges variables': { table: CHARGES_VARIABLES, volet: 'chargeVariable', libelleTotal: 'Total charges variables', hausseFavorable: false },
  'Charges fixes': { table: CHARGES_FIXES, volet: 'chargeFixe', libelleTotal: 'Total charges fixes', hausseFavorable: false },
  'Co-produits': { table: COPRODUITS, volet: 'coproduit', libelleTotal: 'Total co-produits', cleTotal: 'coproduits', hausseFavorable: true },
  'Aides et autres': { table: AUTRES_PRODUITS, volet: 'autresProduits', libelleTotal: 'Total aides et autres produits', hausseFavorable: true }
}

export default {
  name: 'ContenuRestitution',
  components: { SectionRestitution },
  props: {
    ongletActif: {
      type: String,
      default: 'Charges variables'
    },
    restitution: {
      type: Object,
      default: null
    },
    evolution: {
      type: Object,
      default: null
    },
    groupe: {
      type: Object,
      default: null
    },
    unite: {
      type: String,
      default: UNITE_TONNE
    },
    hasEvolution: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    section () {
      return SECTIONS[this.ongletActif] || SECTIONS['Charges variables']
    },
    voletCourant () {
      return this.restitution != null ? this.restitution[this.section.volet] : null
    },
    voletEvolution () {
      return this.evolution != null ? this.evolution[this.section.volet] : null
    },
    voletGroupe () {
      return this.groupe != null ? this.groupe[this.section.volet] : undefined
    },
    blocs () {
      return construireSection(this.section.table, this.voletCourant, this.voletEvolution, this.voletGroupe, this.unite)
    },
    libelleTotal () {
      return this.section.libelleTotal || ''
    },
    cleTotal () {
      return this.section.cleTotal || 'total'
    },
    hausseFavorable () {
      return this.section.hausseFavorable
    },
    champTotal () {
      return this.voletCourant != null ? this.voletCourant[this.cleTotal] : null
    },
    evolutionTotal () {
      if (this.voletEvolution == null) {
        return null
      }
      return pourcentageEvolution(this.voletEvolution[this.cleTotal])
    },
    valeursEvolutionTotal () {
      if (this.voletEvolution == null) {
        return {}
      }
      return valeursParAnnee(this.voletEvolution[this.cleTotal], this.unite)
    },
    champTotalGroupe () {
      return this.voletGroupe != null ? this.voletGroupe[this.cleTotal] : undefined
    }
  }
}
</script>
